export function childNodes($el) {
  return Array.from($el.childNodes).filter((n) => {
    return (
      (n.nodeType === Node.ELEMENT_NODE && n.tagName === 'svg') ||
      (n.nodeType === Node.TEXT_NODE && n.data.trim())
    );
  });
}
